import React from "react";
import { Box, Typography } from "@mui/material";
import { useDropzone } from "react-dropzone";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";

export default function FileInput(props) {
  const { onFileDrop } = props;
  const { getRootProps, getInputProps } = useDropzone({
    onDrop: (acceptedFiles) => {
      onFileDrop(acceptedFiles);
    },
  });

  return (
    <Box
      {...getRootProps()}
      sx={{
        border: 1,
        borderRadius: 1,
        p: 2,
        textAlign: "center",
        borderStyle: "dashed",
      }}
    >
      <CloudUploadIcon fontSize="large" color="action" />
      <Typography variant="body2">
        Drag and drop files here, or click to select files (PDF and XML files
        only)
      </Typography>
      {props.formats && (
        <Typography variant="body2">{props.formats}</Typography>
      )}

      <Typography variant="body2">{props.description}</Typography>
      <input {...getInputProps()} />
    </Box>
  );
}
